// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner img{width:100%;-o-object-fit:cover;object-fit:cover}.carousel-indicators .active{width:48px;height:48px;margin:10px;background-color:#ff9}.el-carousel__indicator.is-active button{background-color:#0082f0!important}.banner .el-carousel__button{width:24px!important;height:5px!important;opacity:1!important;margin-right:7px!important}", ""]);
// Exports
module.exports = exports;
